import { Pin } from '../types'

const users = [
  {
    id: 'u1',
    name: 'Sarah Jenkins',
    username: '@sarahj_design',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80',
  },
  {
    id: 'u2',
    name: 'Marcus Chen',
    username: '@marcus_arch',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80',
  },
  {
    id: 'u3',
    name: 'Elena Rodriguez',
    username: '@elena_art',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80',
  },
  {
    id: 'u4',
    name: 'David Kim',
    username: '@dkim_photo',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&q=80',
  },
]

const getDims = (type: 'tall' | 'square' | 'wide') => {
  const width = 600
  let height = 600
  if (type === 'tall') height = Math.floor(Math.random() * (1000 - 700) + 700)
  if (type === 'wide') height = Math.floor(Math.random() * (500 - 400) + 400)
  return { width, height }
}

export const mockPins: Pin[] = [
  // Interior
  {
    id: '1',
    title: 'Minimalist Interior',
    description:
      'Clean lines and soft lighting for a modern living room setup.',
    imageUrl:
      'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[0],
    likes: 1240,
    category: 'Interior',
  },
  {
    id: '16',
    title: 'Scandinavian Bedroom',
    description: 'Cozy Nordic vibes with natural textures.',
    imageUrl:
      'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[1],
    likes: 2100,
    category: 'Interior',
  },
  {
    id: '17',
    title: 'Modern Kitchen',
    description: 'Sleek countertops and pendant lighting.',
    imageUrl:
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[2],
    likes: 890,
    category: 'Interior',
  },
  {
    id: '18',
    title: 'Bohemian Living Room',
    description: 'Eclectic patterns and warm earth tones.',
    imageUrl:
      'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[3],
    likes: 1560,
    category: 'Interior',
  },

  // Art
  {
    id: '2',
    title: 'Swiss Typography',
    description: 'Classic grid systems in modern poster design.',
    imageUrl:
      'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[1],
    likes: 856,
    category: 'Art',
  },
  {
    id: '3',
    title: 'Ceramic Texture',
    description: 'Handmade pottery with unique glazing techniques.',
    imageUrl:
      'https://images.unsplash.com/photo-1610701596007-11502861dcfa?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[2],
    likes: 2300,
    category: 'Art',
  },
  {
    id: '6',
    title: 'Abstract Shapes',
    description: 'Digital art exploration using primary colors.',
    imageUrl:
      'https://images.unsplash.com/photo-1549490349-8643362247b5?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[2],
    likes: 3400,
    category: 'Art',
  },
  {
    id: '19',
    title: 'Oil Painting',
    description: 'Classical technique meets modern subjects.',
    imageUrl:
      'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[0],
    likes: 1890,
    category: 'Art',
  },

  // Nature
  {
    id: '7',
    title: 'Plant Life',
    description: 'Monstera deliciosa care tips and tricks.',
    imageUrl:
      'https://images.unsplash.com/photo-1525498128493-380d1990a112?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[0],
    likes: 890,
    category: 'Nature',
  },
  {
    id: '9',
    title: 'Mountain Retreat',
    description: 'Cozy cabin vibes for the winter season.',
    imageUrl:
      'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[1],
    likes: 2100,
    category: 'Nature',
  },
  {
    id: '13',
    title: 'Desert Dunes',
    description: 'Minimalist landscape photography.',
    imageUrl:
      'https://images.unsplash.com/photo-1509316975850-ff9c5deb0cd9?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[2],
    likes: 3200,
    category: 'Nature',
  },
  {
    id: '15',
    title: 'Ocean Waves',
    description: 'Aerial view of the Pacific coastline.',
    imageUrl:
      'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[3],
    likes: 2750,
    category: 'Nature',
  },
  {
    id: '20',
    title: 'Forest Path',
    description: 'Misty morning walk through ancient woods.',
    imageUrl:
      'https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[1],
    likes: 1340,
    category: 'Nature',
  },

  // Food
  {
    id: '5',
    title: 'Morning Coffee',
    description: 'The perfect pour over to start the day.',
    imageUrl:
      'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[3],
    likes: 120,
    category: 'Food',
  },
  {
    id: '10',
    title: 'Healthy Breakfast',
    description: 'Avocado toast with poached eggs.',
    imageUrl:
      'https://images.unsplash.com/photo-1525351484163-7529414395d8?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[0],
    likes: 430,
    category: 'Food',
  },
  {
    id: '21',
    title: 'Sushi Platter',
    description: 'Fresh Japanese cuisine artfully arranged.',
    imageUrl:
      'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[2],
    likes: 2890,
    category: 'Food',
  },
  {
    id: '22',
    title: 'Homemade Pasta',
    description: 'Italian comfort food at its finest.',
    imageUrl:
      'https://images.unsplash.com/photo-1551183053-bf91a1d81141?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[1],
    likes: 1670,
    category: 'Food',
  },
  {
    id: '23',
    title: 'Artisan Bread',
    description: 'Sourdough perfection with crispy crust.',
    imageUrl:
      'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[3],
    likes: 980,
    category: 'Food',
  },

  // Fashion
  {
    id: '14',
    title: 'Fashion Week',
    description: 'Street style trends from Paris.',
    imageUrl:
      'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[0],
    likes: 1800,
    category: 'Fashion',
  },
  {
    id: '24',
    title: 'Minimalist Wardrobe',
    description: 'Capsule collection essentials.',
    imageUrl:
      'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[2],
    likes: 2340,
    category: 'Fashion',
  },
  {
    id: '25',
    title: 'Vintage Denim',
    description: 'Classic jeans styling inspiration.',
    imageUrl:
      'https://images.unsplash.com/photo-1542272604-787c3835535d?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[1],
    likes: 1120,
    category: 'Fashion',
  },
  {
    id: '26',
    title: 'Sneaker Collection',
    description: 'Must-have kicks for every occasion.',
    imageUrl:
      'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[3],
    likes: 3450,
    category: 'Fashion',
  },

  // Tech
  {
    id: '12',
    title: 'Workspace Goals',
    description: 'Productivity setup with dual monitors.',
    imageUrl:
      'https://images.unsplash.com/photo-1493934558415-9d19f0b2b4d2?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[1],
    likes: 980,
    category: 'Tech',
  },
  {
    id: '27',
    title: 'Mechanical Keyboard',
    description: 'Custom keycaps and RGB lighting.',
    imageUrl:
      'https://images.unsplash.com/photo-1618384887929-16ec33fab9ef?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[0],
    likes: 4200,
    category: 'Tech',
  },
  {
    id: '28',
    title: 'Smart Home Setup',
    description: 'Automated living with voice control.',
    imageUrl:
      'https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[2],
    likes: 1890,
    category: 'Tech',
  },
  {
    id: '29',
    title: 'Gaming Station',
    description: 'Ultimate setup for serious gamers.',
    imageUrl:
      'https://images.unsplash.com/photo-1598550476439-6847785fcea6?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[3],
    likes: 5670,
    category: 'Tech',
  },

  // Travel
  {
    id: '4',
    title: 'Urban Architecture',
    description: 'Concrete jungle vibes from downtown Chicago.',
    imageUrl:
      'https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[1],
    likes: 450,
    category: 'Travel',
  },
  {
    id: '8',
    title: 'Neon Nights',
    description: 'Cyberpunk aesthetics in Tokyo streets.',
    imageUrl:
      'https://images.unsplash.com/photo-1555680202-c86f0e12f086?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[3],
    likes: 5600,
    category: 'Travel',
  },
  {
    id: '30',
    title: 'Santorini Sunset',
    description: 'Greek island magic at golden hour.',
    imageUrl:
      'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[0],
    likes: 4890,
    category: 'Travel',
  },
  {
    id: '31',
    title: 'Northern Lights',
    description: 'Aurora borealis in Iceland.',
    imageUrl:
      'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?auto=format&fit=crop&w=600&q=80',
    ...getDims('wide'),
    user: users[2],
    likes: 6780,
    category: 'Travel',
  },
  {
    id: '32',
    title: 'Venice Canals',
    description: 'Romantic gondola rides at dusk.',
    imageUrl:
      'https://images.unsplash.com/photo-1514890547357-a9ee288728e0?auto=format&fit=crop&w=600&q=80',
    ...getDims('square'),
    user: users[1],
    likes: 3210,
    category: 'Travel',
  },

  // Additional mixed
  {
    id: '11',
    title: 'Vintage Film',
    description: 'Analog photography collection from the 70s.',
    imageUrl:
      'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&w=600&q=80',
    ...getDims('tall'),
    user: users[3],
    likes: 1500,
    category: 'Art',
  },
]
